// extracted by mini-css-extract-plugin
export var copy = "styles-module--copy--363d1";
export var disabled = "styles-module--disabled--6ad82";
export var share = "styles-module--share--148de";
export var wrapper = "styles-module--wrapper--dda99";